import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag/use-feature-flag';
import { FEATURE_VULNERABILITIES } from '@/shared/hooks/use-feature-flag/use-feature-flag.constants';
import { usePollingQuery } from '@/shared/hooks/use-polling-query/use-polling-query';
import { useReadDeviceVulnerabilitySummaryQuery } from '@/shared/redux/api/assets/vulnerabilities/vulnerabilities-api';

const VULNERABILITY_WARNING_POLLING_INTERVAL_MS = 60_000;

export const useVulnerabilityWarning = () => {
  const { isFeatureFlagEnabled } = useFeatureFlag();
  const { can } = usePermissionCheck();
  const featureEnabled = isFeatureFlagEnabled(FEATURE_VULNERABILITIES);
  const hasVulnerabilitiesReadPermission = can(
    'vulnerabilities:readVulnerabilities',
  );

  const { data } = usePollingQuery({
    useQueryHook: useReadDeviceVulnerabilitySummaryQuery,
    queryArg: undefined,
    pollingInterval: VULNERABILITY_WARNING_POLLING_INTERVAL_MS,
    queryOptions: {
      skip: !featureEnabled || !hasVulnerabilitiesReadPermission,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  });

  const vulnerabilitiesCount =
    data?.readAllDeviceVulnerabilities?.itemCount ?? 0;
  const affectedDevicesCount = new Set(
    data?.readAllDeviceVulnerabilities?.items.map((item) => item.deviceId) ??
      [],
  ).size;

  return {
    vulnerabilitiesCount,
    affectedDevicesCount,
  };
};
